const ShowNotification = Object.freeze({    
    Everywhere: 0,
    Except: 1,
    Only: 2
  });
  
  export { ShowNotification };